import React from 'react';
import { COLORS, Typography } from '@fupa/fupa-uikit';
import { TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { FlexContainer } from 'app/styles/content';
const Container = styled(FlexContainer).withConfig({
  componentId: "sc-13abb98-0"
})(["width:100%;flex-direction:column;align-items:center;margin-top:1rem;flex-wrap:wrap;border:1px solid ", ";border-radius:0.5rem;padding-bottom:0.5rem;justify-content:center;.MuiCollapse-wrapperInner{display:flex;justify-content:center;}"], COLORS.lightGrey);
const Label = styled(Typography).withConfig({
  componentId: "sc-13abb98-1"
})(["color:", ";background:", ";margin:-0.75rem auto auto;padding:0 0.5rem;"], COLORS.darkGrey, COLORS.white);
const Box = styled(FlexContainer).withConfig({
  componentId: "sc-13abb98-2"
})(["width:100%;z-index:1;justify-content:flex-start;flex-direction:column;align-items:center;padding-bottom:0.25rem;"]);
const MatchDetailEventSummary = _ref => {
  let {
    label,
    caption,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "MatchDetailEventSummary",
    "data-sentry-source-file": "MatchDetailEventSummary.tsx"
  }, /*#__PURE__*/React.createElement(Box, {
    "data-sentry-element": "Box",
    "data-sentry-source-file": "MatchDetailEventSummary.tsx"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: 'body-strong',
    "data-sentry-element": "Label",
    "data-sentry-source-file": "MatchDetailEventSummary.tsx"
  }, label), caption && /*#__PURE__*/React.createElement(Typography, {
    variant: 'caption2'
  }, caption)), /*#__PURE__*/React.createElement(TransitionGroup, {
    style: {
      width: '100%'
    },
    "data-sentry-element": "TransitionGroup",
    "data-sentry-source-file": "MatchDetailEventSummary.tsx"
  }, children));
};
export default MatchDetailEventSummary;